import { create } from 'zustand';
import type { LedgerEntry } from '../transactions/entries';
import type { EntryFormKind } from './formSchema';

interface EntrySheetState {
  open: boolean;
  editing: LedgerEntry | null;
  kind: EntryFormKind;
  openNew: (kind?: EntryFormKind) => void;
  openEdit: (entry: LedgerEntry) => void;
  close: () => void;
}

export const useEntrySheet = create<EntrySheetState>((set) => ({
  open: false, editing: null, kind: 'expense',
  openNew: (kind = 'expense') => set({ open: true, editing: null, kind }),
  openEdit: (entry) => set({ open: true, editing: entry }),
  close: () => set({ open: false })
}));
